var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Literal } from 'lincd/models';
import { linkedShape } from '../package.js';
import { UserAccount as SiocUserAccount } from 'lincd-sioc/shapes/UserAccount';
import { profilePlus } from '../ontologies/profile-plus.js';
import { literalProperty } from 'lincd/shapes/SHACL';
import { Boolean } from 'lincd-xsd/shapes/Boolean';
import { xsd } from 'lincd-xsd/ontologies/xsd';
let UserAccount = class UserAccount extends SiocUserAccount {
    get enabledLocationServices() {
        return Boolean.isTrue(this.getOne(profilePlus.enabledLocationServices));
    }
    set enabledLocationServices(val) {
        this.overwrite(profilePlus.enabledLocationServices, val ? Boolean.true() : Boolean.false());
    }
    get enabledNotifications() {
        return Boolean.isTrue(this.getOne(profilePlus.enabledNotifications));
    }
    set enabledNotifications(val) {
        this.overwrite(profilePlus.enabledNotifications, val ? Boolean.true() : Boolean.false());
    }
    /**
     * Peace Flame (plan 003): stable per-device cookie value for guest UserAccounts.
     * Anonymous visitors get a guest UserAccount keyed by their lincd_sticky cookie;
     * on signin the merge hook clears this field as the guest is merged into the real account.
     * Real signed-up users typically don't have this set.
     */
    get deviceId() {
        return this.getValue(profilePlus.deviceId);
    }
    set deviceId(val) {
        this.overwrite(profilePlus.deviceId, val ? new Literal(val) : null);
    }
};
UserAccount.targetClass = profilePlus.UserAccount;
__decorate([
    literalProperty({
        path: profilePlus.enabledLocationServices,
        datatype: Boolean.targetClass,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], UserAccount.prototype, "enabledLocationServices", null);
__decorate([
    literalProperty({
        path: profilePlus.enabledNotifications,
        datatype: Boolean.targetClass,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], UserAccount.prototype, "enabledNotifications", null);
__decorate([
    literalProperty({
        path: profilePlus.deviceId,
        datatype: xsd.string,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], UserAccount.prototype, "deviceId", null);
UserAccount = __decorate([
    linkedShape
], UserAccount);
export { UserAccount };
//# sourceMappingURL=UserAccount.js.map